<div
  class="p-4 sm:p-0"
  [ngClass]="{
    'bg-image-default': router.url !== '/select-organization',
    'bg-image-select': router.url === '/select-organization'
  }"
>
  <router-outlet />
</div>
